import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { Card, Image } from '@platzi/ui';
import { LOCALES } from '@platzi/commons';
import styles from './ChallengesCard.module.sass';

export const ChallengesCard = (props) => {
  const { t } = useTranslation();
  const locale = useSelector((state) => state.get('header').get('locale'));

  const isBrasil = locale === LOCALES.PORTUGUESE;
  const cardUrl = isBrasil ? `/desafios/${props.slug}/` : `/retos/${props.slug}/`;

  const handleStatusMessage = () => {
    switch (props.status) {
      case 'joined':
        return (
          <span className={styles.Joined}>
            <FontAwesomeIcon icon={faCheckCircle} />
            {t('escuela.challengesCard.joined')}
          </span>
        );
      case 'plan_required':
        return <span>{t('escuela.challengesCard.readyToJoin')}</span>;
      case 'ready_to_join':
        return <span>{t('escuela.challengesCard.readyToJoin')}</span>;
      case 'closed':
        return <span className={styles.closed}>{t('escuela.challengesCard.closed')}</span>;
      default:
        return <span className={styles.closed}>{t('escuela.challengesCard.closed')}</span>;
    }
  };

  return (
    <Card isDark customClass={styles.ChallengesCard}>
      <a href={cardUrl}>
        <figure>
          <Image src={props?.thumbnail} alt={props?.title} />
        </figure>
        <div className={styles.Content}>
          <h3>{props?.title}</h3>
          <p>{props?.description}</p>
          {handleStatusMessage()}
        </div>
      </a>
    </Card>
  );
};
